module.exports = __webpack_public_path__ + "static/media/26UNRWA6.a090b8c8.jpg";